import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfigResponseData, GetImportState } from '../actions/types/ImportAllJourneySummaryTypes';

/**
 * Initial Event state in store
 */
const initialState: GetImportState = {
  isLoading: false,
  success: false,
  errorMessage: '',
  errorCode: '',
  config: {
    correlationId: '',
    totalRecordsCount: 0,
    totalSuccessRecordsCount: 0,
    totalFailureRecordsCount: 0,
    sourceEnv: '',
    createdBy: '',
    createdTimestamp: '',
    records: []
  }
};

/**
 * Create Journey Slice to Import journey summary
 */
export const importJourneySummarySlice = createSlice({
  name: 'importJourneySummary',
  initialState,
  reducers: {
    importJourneySummaryStarted: (state) => {
      state.isLoading = true;
    },

    importJourneySummarySuccess: (state, action: PayloadAction<ConfigResponseData>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.config = action.payload;
    },

    importJourneySummaryFail: (state, action: PayloadAction<{ errorCode: string, errorMessage: string }>) => {
      state.isLoading = false;
      state.success = false;
      state.errorCode = action.payload.errorCode;
      state.errorMessage = action.payload.errorMessage;
    },

    clearImportJourneySummary: (state,) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.config = initialState.config;
    }
  }
});

export const { importJourneySummaryStarted, importJourneySummarySuccess, importJourneySummaryFail, clearImportJourneySummary } = importJourneySummarySlice.actions;
export default importJourneySummarySlice.reducer;
